"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductQuantity = void 0;
var getProductQuantity = function (product) {
    if (!product)
        return undefined;
    var piecesMsg = product.pieces ? "".concat(product.pieces, " pi\u00E8ce").concat(product.pieces > 1 ? 's' : '') : '';
    var weightMsg = product.weight ? "~".concat(product.weight, "kg") : '';
    return [piecesMsg, weightMsg].filter(Boolean).join(', ');
};
exports.getProductQuantity = getProductQuantity;
exports.default = { getProductQuantity: exports.getProductQuantity };
//# sourceMappingURL=ProductQuantity.js.map